import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer, Accordion, ShortcutLink } from '@next-nx/shared-ui/atoms'
import { BoxLink } from '@next-nx/shared-ui/molecules'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './FaqAssistenzaSection.module.sass'


interface Props {
  item: MenuItemType
  boxLinkItem?: MenuItemType
  className?: string
}

const FaqAssistenzaSection = (props: Props) => {

  const { 
    item = undefined,
    boxLinkItem = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, category?: string, title?: string) => {
    const action_timestamp = getTimestamp()
    let dlObj = {}

    switch (action_type) {
      case 'consulta_faq':
        dlObj = {
          virtual: 'action', 
          action_name: 'navigazione',  
          action_tech: 'click', 
          action_type: 'consulta_faq',
          action_timestamp,
          action_effect: 'interazione_componente_faq',
          faq_category: title?.replace(/\-|\s+/g, '_').toLowerCase(),
          faq_title: title?.replace(/\-|\s+/g, '_').toLowerCase(),
        }
        break;
      default:
        dlObj = {
          virtual: 'action', 
          action_name: 'navigazione',  
          action_tech: 'click', 
          action_type: 'vai_alle_faq',
          action_timestamp,
          action_effect: 'interazione_componente_faq',
        }
        break;
    }

    linkDataLayer(dlObj)
  }

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.main}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {!!item.description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description }} />}
            <div className={styles.list}>
              {item?.children?.edges?.map(x => x.node).map(x => (
                <ShortcutLink key={x.pk} itemName={x.name} itemUrl={x.url} colorVariant="white" sezione="consulta_faq" handleTracking={handleTracking} />
              ))}
            </div>
          </div>
          {boxLinkItem && (
            <div className={styles.sidebar}>
              <BoxLink item={boxLinkItem} handleTracking={handleTracking} />
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default FaqAssistenzaSection
